






















































import Vue from "vue";
import MenuItem from "./MenuItem.vue";
import abacusLogo from "@/assets/images/ABACUS_Logo_White.png";
import playButton from "@/assets/images/play-button.png";
import dietaryFilters from "@/assets/images/dietary-filters.png";
import SidebarItem from "./SidebarItem.vue";
import CancelOrder from "./CancelOrder.vue";
import Totals from "./Totals.vue";

export default Vue.extend({
  props: {
    backgroundPhotos: { type: Object },
    fonts: { type: Object },
    colors: { type: Object },
    menuColumnsCount: { type: Number, default: 2 }
  },
  data() {
    return {
      abacusLogo,
      playButton,
      dietaryFilters
    };
  },
  components: {
    MenuItem,
    SidebarItem,
    CancelOrder,
    Totals
  }
});
